import axios from 'axios'

// const url = 'http://103.41.205.87:80/api/v1/application';
// const urlEvent = 'http://103.41.205.87:80/event';
// const urlSuperStudent = 'http://103.41.205.87:80';
// const urlRegister = 'http://103.41.205.87:80/api/v1';
// const baseSuperStudent = 'http://103.41.205.87:80/storage';

const url = 'https://development.niecindonesia.com/api/v1/application';
const urlEvent = 'https://development.niecindonesia.com/event';
const urlSuperStudent = 'https://development.niecindonesia.com';
const urlRegister = 'https://development.niecindonesia.com/api/v1';
const baseSuperStudent = 'https://development.niecindonesia.com/storage';
const urlDevelopment = 'https://development.niecindonesia.com';

const baseUrl =  axios.create({
    baseURL: url,
    timeout: 10000,
    headers:{
        'Content-Type': 'application/json'
    }
})

const development =  axios.create({
    baseURL: urlDevelopment,
    timeout: 10000,
    headers:{
        'Content-Type': 'application/json',
        'Authorization': `Bearer eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ`
    }
})

const eventUrl =  axios.create({
    baseURL: urlEvent,
    timeout: 10000,
    headers:{
        'Content-Type': 'application/json',
        'Authorization': `Bearer eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ`
    }
})

const superstudent = axios.create({
    baseURL : urlSuperStudent,
    timeout: 10000,
    headers:{
        'Content-Type': 'application/json'
    }
})

const register = axios.create({
    baseURL : urlRegister,
    timeout: 10000,
    headers:{
        'Content-Type': 'application/json'
    }
})

const API_URL = {
    baseUrl,
    eventUrl,
    superstudent,
    register,
    development
}

export default API_URL